import {SORT1_SUCCESS, SORT1_ERROR} from '../actions/sort1';

const initialState = {
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === SORT1_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === SORT1_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}